import axios from "axios"
import { REFERRAL_API_URL } from "./constants"

export const referralApi = axios.create({
	baseURL: REFERRAL_API_URL,
	headers: {
		"Content-Type": "application/json",
	},
	withCredentials: true,
})

referralApi.interceptors.response.use(
	response => response,
	async error => {
		const originalRequest = error.config
		const isLoginApi = originalRequest.url.includes("/auth/login")
		const isExtendApi = originalRequest.url.includes("/auth/extend")

		const redirectToLogin = () => {
			const nextUrl = ["/login", "/", "/test/login"].includes(
				window.location.pathname,
			)
				? "/dashboard"
				: window.location.pathname
			if (window.__DF_MODE === "PROD") {
				window.location.href = `/login?nextUrl=${nextUrl}`
			} else {
				window.location.href = `/test/login?nextUrl=${nextUrl}`
			}
			// TODO : after sucessfull login redirect to the original request
		}

		if (!originalRequest._retryCount) {
			originalRequest._retryCount = 0
		}

		if (
			!isLoginApi &&
			!isExtendApi &&
			error.response.status === 401 &&
			originalRequest._retryCount < 5
		) {
			try {
				const response = await referralApi.post("/auth/extend")
				if (response.status == 200) return referralApi(originalRequest)
			} catch (err) {
				console.log(err)
				redirectToLogin()
			}
		}

		if (error.response.status === 401 && !isLoginApi) redirectToLogin()

		return Promise.reject(error)
	},
)
